import { getDeferredPromise } from './promise.util';

type ReadAs = 'text' | 'dataUrl' | 'binary' | 'buffer';

const readAsMethodMap: Record<ReadAs, string> = {
  text: 'readAsText',
  dataUrl: 'readAsDataURL',
  buffer: 'readAsArrayBuffer',
  binary: 'readAsBinaryString',
};

export async function readFile(file: File, readAs: 'text' | 'dataUrl' | 'binary'): Promise<string>;
export async function readFile(file: File, readAs: 'buffer'): Promise<ArrayBuffer>;
export async function readFile(file: File, readAs: ReadAs): Promise<string | ArrayBuffer> {
  const reader = new FileReader();
  const {resolve, reject, promise} = getDeferredPromise<string | ArrayBuffer>();

  reader.onload = (e) => resolve(e.target.result);
  reader.onerror = (e) => reject(e.target);

  reader[readAsMethodMap[readAs]](file);

  return promise;
}

export function getBase64Content(base64: string): string {
  return (base64 ?? '').split(';base64,').pop();
}
